module.exports = __webpack_public_path__ + "static/media/christembassysanantonio.3c5557a4.png";